<div id="username-popup">
    <h3>User name</h3>

    Please select a username.<br>
    <label id = "username-label" for="read_username">(must be unique):</label>
    <input type="text" id="read-username" name="username" bind:value={username}>
    <button class="select-button" id = "username-button" on:click={checkUser} >Submit</button>
    <!-- <button class="select-button" on:click={close} >Close</button> -->

</div>

<style>
    #username-popup {
        background-color: #ccc;
        display: grid;
        grid-template-rows: auto auto;
        padding-top: 0vw;
        padding-left: 1vw;
        padding-bottom: 1vw;

        position: absolute;
        top: 15vh;
        margin-left: 10vw;
        width: 40vw;

        border-style: solid;
        border-radius: 1vh;
        border-width: 0.25vh;
        border-color: black;
        display: none;
    }
    #read-username {
        width:17vw;
    }
</style>

<script>
    import { getUserRecordByUsername, setupInitialData, writeToUser } from './user.js';
    import { elementDisplay } from './utilities.js';
    import { user } from './data-store'
    import { loggedInAs } from './common.js';

    let username = ''

    async function checkUser() {
        if (username == '') {
            alert('You must enter a username');
            return;
        }
        // TODO Check that username has not already been used
        let user_record = await getUserRecordByUsername(username);
        if (user_record == 'already-exists') {
            return;
        }
        $user.username = username;
        setupInitialData()
        writeToUser();
        elementDisplay('username-popup', 'none')
        elementDisplay('main-page', 'grid')
        // let logged_in_as = loggedInAs($user.username);
    }

    function close() {
        elementDisplay('username-popup', 'none')
    }

</script>